import styled from "styled-components";

export const OrderWrapper = styled.div`
  margin-top: -25px;
  overflow-y: auto;
`;

export const OrderMileageWrapper = styled.div`
  padding: 20px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const OrderMileageTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.3px;
`;

export const OrderMileageValue = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  color: #121212;
  text-align: right;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.4px;

  > img {
    width: 24px;
    height: 24px;
  }
`;

export const OrderLine = styled.div`
  width: 100%;
  height: 3px;
  background: var(--Black-100, #f0f0f0);
  margin-bottom: 20px;
`;

export const OrderProductHeader = styled.div`
  padding: 0px 16px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const OrderProductHeaderTitle = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.771px; /* 128.857% */
`;

export const OrderProductList = styled.div`
  padding: 0px 16px 80px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 12px;
  column-gap: 8px;
  overflow-y: auto;
`;

export const OrderProductEmpty = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 180px;

  color: var(--Black-300, #808080);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const OrderProductItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  > img {
    width: 100%;
    aspect-ratio: 1/1;
    border: 1px solid #f0f0f0;
    object-fit: cover;
    border-radius: 8px;
  }

  > .title {
    margin-top: 8px;
    color: #000;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .price {
    margin-top: 4px;
    color: #000;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const OrderCartButton = styled.div`
  position: fixed;
  bottom: 99px;
  left: 50%;
  transform: translateX(-50%);

  border-radius: 12px;
  background: #1f9f81;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  display: flex;
  width: 128px;
  height: 40px;
  justify-content: center;
  align-items: center;

  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const OrderProductSkeleton = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  > .image-skeleton {
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 8px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
  }

  > .title-skeleton {
    margin-top: 8px;
    height: 16px;
    width: 80%;
    border-radius: 4px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
  }

  > .price-skeleton {
    margin-top: 4px;
    height: 16px;
    width: 60%;
    border-radius: 4px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
  }

  @keyframes loading {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;
